import { useCallback, useEffect } from "react";
import { useAppSelector } from "./redux";

export const useHantanaConfig = (): void => {
  const personalInfo = useAppSelector((state) => state.user.personalInfo);

  const setHantanaUserDate = useCallback(() => {
    window.Hantana.setUserData({
      appVersion: `${process.env.REACT_APP_VERSION}-${process.env.REACT_APP_CI_COMMIT_ID}`,
      avatar: personalInfo?.profilePicture,
      description: `userId: ${personalInfo?.id}`,
      email: personalInfo?.email,
      name: personalInfo?.username,
      phone: personalInfo?.phoneNumber,
    });
  }, [personalInfo]);

  const setOpenOnlyOnce = useCallback(() => {
    window.Hantana.openWidgetWelcomeMessageOnlyOnceFeedback();
  }, []);

  const handleHantanaConfig = useCallback(() => {
    setHantanaUserDate();
    setOpenOnlyOnce();
  }, [setHantanaUserDate, setOpenOnlyOnce]);

  useEffect(() => {
    document.addEventListener("hantana_ready", handleHantanaConfig);
    return () => {
      document.removeEventListener("hantana_ready", handleHantanaConfig);
    };
  }, [handleHantanaConfig]);
};
